<template>
  <g>
    <circle cx="12.0002" cy="12" r="6.85714" />
  </g>
</template>
